var _rect, _path, _path2, _path3, _path4, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgShyftLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 95,
    height: 20,
    viewBox: "0 0 95 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    rx: 4,
    fill: "url(#paint0_linear_1423_7947)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.7782 11.319V8.28742L3.22119 3.20001V6.68325L11.7493 9.79853L3.22119 13.2912V16.8L16.7782 11.319Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9463 8.73043C15.9413 8.56428 16.0412 8.4129 16.1959 8.35212C16.4574 8.24942 16.7392 8.44566 16.7336 8.7265L16.6874 11.0388C16.6849 11.1649 16.6119 11.2791 16.4984 11.3342C16.2791 11.4409 16.0229 11.2858 16.0156 11.0421L15.9463 8.73043Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.7782 7.93631L3.22119 13.2816V16.8L16.7782 11.3194V7.93631Z",
    stroke: "url(#paint1_linear_1423_7947)",
    strokeWidth: 0.5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M41.3231 3.10484C39.7963 1.72581 37.5798 1 35.6097 1C32.359 1 28.8619 2.57258 28.8619 6.37097C28.8619 9.46774 31.103 10.5806 33.3194 11.2823C35.6097 12.0081 36.9395 12.4194 36.9395 13.7258C36.9395 15.1048 35.8067 15.5887 34.5261 15.5887C33.147 15.5887 31.5955 14.8145 30.7582 13.7742L28 16.5323C29.5269 18.1048 32.0388 19 34.5261 19C37.9739 19 41.2 17.2339 41.2 13.2903C41.2 9.87903 38.1463 8.8871 35.7821 8.1371C34.1321 7.62903 33.0978 7.26613 33.0978 6.12903C33.0978 4.77419 34.4522 4.41129 35.5358 4.41129C36.6194 4.41129 37.9246 4.99194 38.6388 5.8871L41.3231 3.10484ZM56.4889 18.5645V1.43548H52.2777V7.91935H45.4806V1.43548H41.2695V18.5645H45.4806V11.4032H52.2777V18.5645H56.4889ZM72.5374 1.43548H67.612L63.8934 7.77419L60.1747 1.43548H55.077L61.6277 11.3065V18.5645H65.8389V11.3065L72.5374 1.43548ZM82.6084 4.96774V1.43548H71.1323V18.5645H75.2943V11.9113H82.042V8.5H75.2943V4.96774H82.6084ZM95 4.96774V1.43548H80.9381V4.96774H85.8634V18.5645H90.0746V4.96774H95Z",
    fill: "#112F4A"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1423_7947",
    x1: 1.74359,
    y1: 1.74359,
    x2: 17.641,
    y2: 19.3333,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E0499B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5965F3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1423_7947",
    x1: 1.75778,
    y1: 1.63851,
    x2: 17.9225,
    y2: 20.3047,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E0499B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5965F3"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShyftLogo);
export default __webpack_public_path__ + "static/media/shyft-logo.0c212b81107c053aa60b7cb0c7061830.svg";
export { ForwardRef as ReactComponent };